module.exports = __webpack_public_path__ + "img/liveBroadcast_service.852bfa12.png";